module.exports = __webpack_public_path__ + "static/media/homeBanner.25b63f64.png";